/// <amd-module name="SuiteCommerce.MapAndContactUs.Main"/>
define("SuiteCommerce.MapAndContactUs.Main", ["require", "exports", "SuiteCommerce.MapAndContactInfoCCT", "SuiteCommerce.ContactUsFormCCT", "SuiteCommerce.MapAndContactUs.Common.Instrumentation.Helper", "SuiteCommerce.MapAndContactUs.Common.Configuration"], function (require, exports, MapAndContactInfoCCT, ContactUsFormCCT, Instrumentation_Helper_1, Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            Configuration_1.Configuration.environment = environment;
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
            MapAndContactInfoCCT.mountToApp(container);
            ContactUsFormCCT.mountToApp(container);
        },
    };
});
